import React from 'react';
import { Box, Typography } from '@mui/material';

interface SectionHeaderWithCommandProps {
  icon: React.ReactNode;
  title: string;
  command?: React.ReactNode;
}

const SectionHeaderWithCommand: React.FC<SectionHeaderWithCommandProps> = ({ 
  icon, 
  title, 
  command 
}) => (
  <Box 
    sx={{ 
      mb: 1.5, 
      display: 'flex', 
      justifyContent: command ? 'space-between' : 'flex-start', 
      alignItems: 'center' 
    }}
  >
    <Typography
      variant="subtitle1"
      fontWeight={600}
      color="#1e293b"
      sx={{ display: 'flex', alignItems: 'center' }}
    >
      {icon}
      {title}
    </Typography>
    
    {command && (
      <Box sx={{ minWidth: 200 }}>
        {command}
      </Box>
    )}
  </Box>
);

export default SectionHeaderWithCommand;
